import { useGetPostmarkTemplateQuery } from "store/apis/taskMerchants";
import Async from "./DesignSystem/AsyncComponents/Async";
import Card from "./DesignSystem/Card/Card";
import { Skeleton } from "./DesignSystem/Skeleton/Skeleton";

type WFormEmailPreviewProps = {
  groupName: string;
  season: string;
};

export const WFormEmailPreview = ({
  groupName,
  season,
}: WFormEmailPreviewProps) => {
  const { data, isLoading, isSuccess } = useGetPostmarkTemplateQuery({
    templateKey: "w_form",
  });

  const updatedSubject = data?.template_subject
    ?.replace("from Inkle ", "")
    .replaceAll("{{group_name}}", groupName);
  const templateBody = data?.template_body ?? "";
  const updatedBody = templateBody
    .replaceAll("{{group_name}}", groupName)
    .replaceAll("{{season}}", season)
    .replaceAll("href={{form_url}}", "");

  return (
    <div className="t-border-dashed t-border-neutral-10 t-border t-bg-surface-lighter-grey t-rounded t-p-4 t-min-h-32">
      <Async.Root
        isLoading={isLoading}
        isSuccess={isSuccess}
        isEmpty={false}
        renderOnLoad={
          <Card.Body className="t-space-y-3">
            <Skeleton className="t-min-h-10" />
            <Skeleton className="t-min-h-10" />
            <Skeleton className="t-min-h-10" />
          </Card.Body>
        }
      >
        <Async.Empty>
          <></>
        </Async.Empty>
        <Async.Success>
          <p className="t-text-text-30 t-text-body-sm">
            <strong>Subject:</strong> {updatedSubject}
            <br />
            <br />
            <strong>Body:</strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: updatedBody }} />
          </p>
        </Async.Success>
      </Async.Root>
    </div>
  );
};
